import React, {useEffect, useRef, useState} from 'react';

const StepVerify = ({sendData, setSendData}) => {

  const inputRefs = useRef([]);
  const [timeLeft, setTimeLeft] = useState(120);
  const [code, setCode] = useState(["", "", "", "", ""])

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    }
  }, [timeLeft]);

  const codeHandler = (value, index) => {
    if (!isNaN(value) && value.length <= 1) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      if (value.length === 1 && index < code.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    setSendData({...sendData, code: code.join('')})
  }, [code]);

  try {
    return (
      <div className={"verify-step"}>
        <h5>کد تایید به شماره زیر ارسال شد</h5>
        <div className={"edit-mobile"}>
          <p>{sendData?.mobileNumber}</p>
        </div>

        <div className={"inputs-row"}>
          {code.map((digit, index) => (
            <input
              key={index + "inp"}
              type="number"
              maxLength={1}
              value={digit}
              onChange={(e) => codeHandler(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => inputRefs.current[index] = el}
            />
          ))}
        </div>

        <div className={"send-again"}>
        <span>
          کد را دریافت نکردید؟
          <p>ارسال مجدد</p>
        </span>
          <h5>{formatTime(timeLeft)}</h5>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default StepVerify;